import {
    MISSING_IDENTIFIER_ERROR_CODE, UNKNOWN_ERROR_CODE, 
    AUTHENTICATION_REQUIRED_ERROR_CODE, ACCESS_DENIED_ERROR_CODE,
    NO_SOURCE_ID_ERROR_CODE, DATA_ACCESS_ERROR_CODE, INVALID_ITEM_EXCEPTION_CODE,
    INVALID_REG_NUM_EXCEPTION_CODE, INVALID_HCN_ISSUER_EXCEPTION_CODE, INVALID_HCN_EXCEPTION_CODE,
    INVALID_LN_EXCEPTION_CODE, INVALID_HCN_EXPIRY_EXCEPTION_CODE, INVALID_FN_EXCEPTION_CODE,
    INVALID_DOB_EXCEPTION_CODE, INVALID_DOB_U16_EXCEPTION_CODE, SOAP_FAULT_EXCEPTION_CODE,
    FACILITY_NUMBER_MESSAGE_ID_ERROR, NO_IMMUNIZATION_RECORD_CODE, NO_PATIENT_DATA_CODE,
    NO_IMMUNIZATION_RESULT_RECORD_CODE, INVALID_REGISTRATION_CODE_A, INVALID_REGISTRATION_CODE_B,
    INVALID_REGISTRATION_CODE_C, INVALID_REGISTRATION_CODE_D, INVALID_REGISTRATION_CODE_E,
    INVALID_REGISTRATION_CODE_F, NO_VACCINATION_STATUS_RESULT_CODE, NO_VACCINATION_STATUS_CODE,
    VACCINATION_STATUS_MISSING_PATIENT_DATA_CODE, HIAL_INVALID_LANGUAGE_CODE, HIAL_TIMEOUT_CODE,
    NO_VACCINATION_CREDENTIALS_CODE, QR_CODE_ERROR, IIABE_ERROR, SALESFORCE_EMBED_EXCEPTION_CODE
} from '../api/vsApi';
import { en, fr } from '../globals/strings';
import { LANG_FR } from '../util/language';
import ExtendedError from './extendedError'
export const ERROR_CONTEXT_LOGIN = "login";
export const ERROR_CONTEXT_LOGOUT = "logout";
export const ERROR_CONTEXT_REGISTER = "register";
export const ERROR_CONTEXT_RESULTS = "results";
export const ERROR_CONTEXT_IMMUNIZATION = "immunization";
export const ERROR_CONTEXT_VACCINATION_STATUS = "vaccination_status";
export const ERROR_CONTEXT_PDF = "pdf"

// Get the error code and throw the right exception
export function handleErrors(error, lang, errorContext) {
    let message = "";
    let strings = en;

    // Not sure if this is possible, but just in case
    if (error == null) {
        throw new Error(strings.UNKNOWN_ERROR_MESSAGE);
    }
    // If there is no error, do nothing.
    if (error.error === false) {
        return;
    }
    if (lang === LANG_FR) {
        strings = fr;
    }
    console.log("Handle Errors start..");
    if (error.code === MISSING_IDENTIFIER_ERROR_CODE) {
        throw new ExtendedError(buildErrorMessage(error, strings.MISSING_IDENTIFIER_MESSAGE), error.code, error);
    } else if (error.code === AUTHENTICATION_REQUIRED_ERROR_CODE) {
        if (errorContext != null && errorContext === ERROR_CONTEXT_LOGOUT || errorContext === ERROR_CONTEXT_RESULTS || errorContext ===ERROR_CONTEXT_REGISTER) {
            throw new ExtendedError(buildErrorMessage(error, strings.SESSION_TIMEOUT_ERROR), error.code, error);
        } else {
            throw new ExtendedError(buildErrorMessage(error, strings.AUTHENTICATION_REQUIRED_MESSAGE), error.code, error);
        }
    } else if (error.code === ACCESS_DENIED_ERROR_CODE) {
        if (errorContext != null && errorContext === ERROR_CONTEXT_LOGOUT) {
            throw new ExtendedError(buildErrorMessage(error, strings.SESSION_TIMEOUT_ERROR), error.code, error);
        } else {
            throw new ExtendedError(buildErrorMessage(error, strings.ACCESS_DENIED_MESSAGE), error.code, error);
        }
    } else if (error.code === NO_SOURCE_ID_ERROR_CODE) {
        throw new ExtendedError(buildErrorMessage(error, strings.NO_ID_MESSAGE), error.code, error);
    } else if (error.code === UNKNOWN_ERROR_CODE) {
        throw new ExtendedError(buildErrorMessage(error, strings.UNKNOWN_ERROR_MESSAGE), error.code, error);
    } else if (error.code === DATA_ACCESS_ERROR_CODE) {
        throw new ExtendedError(buildErrorMessage(error, strings.DATA_ACCESS_MESSAGE), error.code, error);
    } else if (error.code === INVALID_ITEM_EXCEPTION_CODE) {
        throw new ExtendedError(buildErrorMessage(error, strings.REG_ERROR_INVALID_ITEM), error.code, error);
    } else if (error.code === HIAL_INVALID_LANGUAGE_CODE) {
        console.log("INVALID LANGUAGE: " + lang);
        throw new ExtendedError(error.message + " " + lang, error.code, error);
    } else if (error.code === HIAL_TIMEOUT_CODE) {
        throw new ExtendedError(buildErrorMessage(error, strings.DATA_ACCESS_MESSAGE), error.code, error);
    } else if (error.code === INVALID_REGISTRATION_CODE_D) {
        if (errorContext != null && errorContext === ERROR_CONTEXT_REGISTER){
            throw new ExtendedError(error.message, error.code, error);
        } else {
            throw new ExtendedError(buildErrorMessage(error, strings.UNKNOWN_ERROR_MESSAGE), error.code, error);
        }
    } else if (error.code === INVALID_REGISTRATION_CODE_E) {
        if (errorContext != null && errorContext === ERROR_CONTEXT_REGISTER){
            throw new ExtendedError(error.message, error.code, error);
        } else {
            throw new ExtendedError(buildErrorMessage(error, strings.UNKNOWN_ERROR_MESSAGE), error.code, error);
        }
    } else if (error.code === INVALID_REGISTRATION_CODE_F) {
        if (errorContext != null && errorContext === ERROR_CONTEXT_REGISTER){
            throw new ExtendedError(error.message, error.code, error);
        } else {
            throw new ExtendedError(buildErrorMessage(error, strings.UNKNOWN_ERROR_MESSAGE), error.code, error);
        }
    } else if(error.code === INVALID_REG_NUM_EXCEPTION_CODE){
        if (errorContext != null && errorContext === ERROR_CONTEXT_REGISTER) {
            throw new ExtendedError(error.message, error.code, error);
        } else {
            throw new ExtendedError(buildErrorMessage(error, strings.UNKNOWN_ERROR_MESSAGE), error.code, error);
        }
    } else if(error.code === INVALID_HCN_ISSUER_EXCEPTION_CODE){
        if (errorContext != null && errorContext === ERROR_CONTEXT_REGISTER) {
            throw new ExtendedError(error.message, error.code, error);
        } else {
            throw new ExtendedError(buildErrorMessage(error, strings.UNKNOWN_ERROR_MESSAGE), error.code, error);
        }
    } else if(error.code === INVALID_HCN_EXCEPTION_CODE){
        if (errorContext != null && errorContext === ERROR_CONTEXT_REGISTER) {
            throw new ExtendedError(error.message, error.code, error);
        } else {
            throw new ExtendedError(buildErrorMessage(error, strings.UNKNOWN_ERROR_MESSAGE), error.code, error);
        }
    } else if(error.code === INVALID_LN_EXCEPTION_CODE){
        if (errorContext != null && errorContext === ERROR_CONTEXT_REGISTER) {
            throw new ExtendedError(error.message, error.code, error);
        } else {
            throw new ExtendedError(buildErrorMessage(error, strings.UNKNOWN_ERROR_MESSAGE), error.code, error);
        }
    } else if(error.code === INVALID_HCN_EXPIRY_EXCEPTION_CODE){
        if (errorContext != null && errorContext === ERROR_CONTEXT_REGISTER) {
            throw new ExtendedError(error.message, error.code, error);
        } else {
            throw new ExtendedError(buildErrorMessage(error, strings.UNKNOWN_ERROR_MESSAGE), error.code, error);
        }
    } else if(error.code === INVALID_DOB_EXCEPTION_CODE){
        if (errorContext != null && errorContext === ERROR_CONTEXT_REGISTER) {
            throw new ExtendedError(error.message, error.code, error);
        } else {
            throw new ExtendedError(buildErrorMessage(error, strings.UNKNOWN_ERROR_MESSAGE), error.code, error);
        }
    } else if(error.code === INVALID_DOB_U16_EXCEPTION_CODE){
        if (errorContext != null && errorContext === ERROR_CONTEXT_REGISTER) {
            throw new ExtendedError(error.message, error.code, error);
        } else {
            throw new ExtendedError(buildErrorMessage(error, strings.UNKNOWN_ERROR_MESSAGE), error.code, error);
        }
    } else if(error.code === INVALID_FN_EXCEPTION_CODE){
        if (errorContext != null && errorContext === ERROR_CONTEXT_REGISTER) {
            throw new ExtendedError(error.message, error.code, error);
        } else {
            throw new ExtendedError(buildErrorMessage(error, strings.UNKNOWN_ERROR_MESSAGE), error.code, error);
        }
    } else if(error.code === SOAP_FAULT_EXCEPTION_CODE){
        throw new ExtendedError(buildErrorMessage(error, strings.HIAL999_ERROR_MESSAGE), error.code, error);
    } else if (error.code === INVALID_REGISTRATION_CODE_A) {
        if (errorContext != null && errorContext === ERROR_CONTEXT_REGISTER){
            throw new ExtendedError(error.message, error.code, error);
        } else {
            throw new ExtendedError(buildErrorMessage(error, strings.UNKNOWN_ERROR_MESSAGE), error.code, error);
        }
    } else if (error.code === INVALID_REGISTRATION_CODE_B) {
        if (errorContext != null && errorContext === ERROR_CONTEXT_REGISTER){
            throw new ExtendedError(error.message, error.code, error);
        } else {
            throw new ExtendedError(buildErrorMessage(error, strings.UNKNOWN_ERROR_MESSAGE), error.code, error);
        }
    } else if (error.code === INVALID_REGISTRATION_CODE_C) {
        if (errorContext != null && errorContext === ERROR_CONTEXT_REGISTER){
            throw new ExtendedError(error.message, error.code, error);
        } else {
            throw new ExtendedError(buildErrorMessage(error, strings.UNKNOWN_ERROR_MESSAGE), error.code, error);
        }
    } else if(error.code === FACILITY_NUMBER_MESSAGE_ID_ERROR){
        throw new ExtendedError(error.message, error.code, error);
    } else if(error.code === NO_IMMUNIZATION_RECORD_CODE) {
        return;
    } else if(error.code === NO_PATIENT_DATA_CODE) {
        if (errorContext != null && errorContext === ERROR_CONTEXT_IMMUNIZATION) {
            throw new ExtendedError(buildErrorMessage(error, strings.HIAL806_ERROR_MESSAGE + strings.HIAL_DEFAULT_ERROR), error.code, error);
        } else {
            throw new ExtendedError(buildErrorMessage(error, strings.UNKNOWN_ERROR_MESSAGE), error.code, error);
        }
    } else if (error.code === NO_IMMUNIZATION_RESULT_RECORD_CODE) {
        throw new ExtendedError(buildErrorMessage(error, strings.HIAL804_ERROR_MESSAGE), error.code, error);
    } else if (error.code === NO_VACCINATION_STATUS_RESULT_CODE) {
        throw new ExtendedError(buildErrorMessage(error, strings.HIAL904_ERROR_MESSAGE), error.code, error);
    } else if (error.code === NO_VACCINATION_STATUS_CODE) {
        throw new ExtendedError(buildErrorMessage(error, strings.HIAL905_ERROR_MESSAGE), error.code, error);
    } else if (error.code === VACCINATION_STATUS_MISSING_PATIENT_DATA_CODE) {
        throw new ExtendedError(buildErrorMessage(error, strings.HIAL906_ERROR_MESSAGE + strings.HIAL_DEFAULT_ERROR), error.code, error);
    } else if (error.code === NO_VACCINATION_CREDENTIALS_CODE) {
        throw new ExtendedError(buildErrorMessage(error, strings.HIAL907_ERROR_MESSAGE), error.code, error);
    } else if (error.code === QR_CODE_ERROR) {
        throw new ExtendedError(buildErrorMessage(error, strings.QRCE_ERROR_MESSAGE), error.code, error);
    } else if (error.code === IIABE_ERROR) {
        throw new ExtendedError(buildErrorMessage(error, strings.IIABE_ERROR_MESSAGE), error.code, error);
    } else if (error.code === SALESFORCE_EMBED_EXCEPTION_CODE) {
        throw new ExtendedError(strings.ERROR_HEADER+' '+error.code+': '+ strings.SFEE_ERROR_MESSAGE, error.code, error);
    } else {
        throw new ExtendedError(buildErrorMessage(error, strings.UNKNOWN_ERROR_MESSAGE), error.code, error);
    }
}

function buildErrorMessage(error, message) {
    let id = "";
    if (error.id != null) {
        id = error.id;
    }
    return message + " (" + error.code + " - " + error.statusCode + " - " + id + ")";
}

function buildSupportErrorMessage(strings) {
    return strings.DEFAULT_SUPPORT_ERROR + strings.DEFAULT_SUPPORT_ERROR_PHONE;
}

export function createError(code, statusCode, id, message) {
   return { error: true, code: code, id: id, statusCode: statusCode, message: message }
}
